import React, { useState, useEffect } from 'react';
import Map from './map';
import PlacesList from './PlacesList';
import PlacePopup from './PlacePopup';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../Firebase/Firebase';
import './MapShow.css';

const MapShow = ({ onSelectSpace, onSelectPlace, onClosePopup }) => {
    const [places, setPlaces] = useState([]);
    const [spaces, setSpaces] = useState([]);
    const [filteredPlaces, setFilteredPlaces] = useState([]);
    const [selectedPlace, setSelectedPlace] = useState(null);
    const [selectedSpace, setSelectedSpace] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [availableTypes, setAvailableTypes] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [selectedType, setSelectedType] = useState('todos');

    useEffect(() => {
        const fetchPlaces = async () => {
            const querySnapshot = await getDocs(collection(db, 'lugar'));
            const placesData = await Promise.all(querySnapshot.docs.map(async doc => {
                const data = doc.data();
                const espaciosSnapshot = await getDocs(collection(db, 'lugar', doc.id, 'espacios'));
                const espacios = espaciosSnapshot.docs.map(espacioDoc => ({
                    id: espacioDoc.id,
                    ...espacioDoc.data()
                }));
                return {
                    id: doc.id,
                    ...data,
                    espacios
                };
            }));
            setPlaces(placesData);
            setFilteredPlaces(placesData);
            fetchTypes(placesData);
        };

        const fetchTypes = (placesData) => {
            const allTypes = placesData.flatMap(place => place.espacios.map(espacio => espacio.tipo));
            const uniqueTypes = Array.from(new Set(allTypes));
            setAvailableTypes(uniqueTypes);
        };

        fetchPlaces();
    }, []);

    const handleTypeChange = (event) => {
        const selectedType = event.target.value;
        setSelectedType(selectedType);
        filterPlaces(searchValue, selectedType);
    };

    const handleSearchChange = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchValue(value);
        filterPlaces(value, selectedType);
    };

    const filterPlaces = (searchValue, selectedType) => {
        let filtered = Array.isArray(places) ? places.filter(place => place.nombreL.toLowerCase().includes(searchValue)) : [];
        if (selectedType !== 'todos') {
            filtered = filtered.filter(place => place.espacios.some(espacio => espacio.tipo === selectedType));
        }
        setFilteredPlaces(filtered);
    };

    const handleMarkerClick = async (place) => {
        setSelectedPlace(place);
        setSpaces(Array.isArray(place.espacios) ? place.espacios : []);
        if (onSelectPlace) {
            onSelectPlace(place);
        }
    };

    const handleSpaceClick = (space) => {
        setSelectedSpace(space);
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        if (onClosePopup) {
            onClosePopup();
        }
    };

    const reserveSpace = (space) => {
        if (onSelectSpace) {
            onSelectSpace(space);
        }
        setIsPopupOpen(false);
    };

    return (
        <div className='mapShow-container'>
            <div className="search-bar">
                <input
                    type="text"
                    placeholder="Buscar nombre del lugar"
                    value={searchValue}
                    onChange={handleSearchChange}
                />
                <select onChange={handleTypeChange} value={selectedType}>
                    <option value="todos">Todos</option>
                    {availableTypes.map((type, index) => (
                        <option key={index} value={type}>{type}</option>
                    ))}
                </select>
            </div>
            <div className="main-content">
                <div className="map-container">
                    <Map onMarkerClick={handleMarkerClick} filteredPlaces={Array.isArray(filteredPlaces) ? filteredPlaces : []} />
                </div>
                {selectedPlace && (
                    <>
                        <div className="sidebar1">
                            <PlacesList places={[selectedPlace]} onCardClick={() => { }} />
                        </div>
                        <div className="sidebar2">
                            <h3>Espacios</h3>
                            {Array.isArray(spaces) && spaces.sort((a, b) => a.nombreEspacio.localeCompare(b.nombreEspacio)).map((space) => (
                                <div key={space.id} onClick={() => handleSpaceClick(space)} className="space-item">
                                    <p>{space.nombreEspacio}</p>
                                </div>
                            ))}
                        </div>
                    </>
                )}
                {selectedSpace && (
                    <PlacePopup
                        place={selectedSpace}
                        isOpen={isPopupOpen}
                        onRequestClose={closePopup}
                        onReserve={() => reserveSpace(selectedSpace)}
                    />
                )}
            </div>
        </div>
    );
};

export default MapShow;
